import { render, staticRenderFns } from "./DialogElement.vue?vue&type=template&id=297b0423"
import script from "./DialogElement.vue?vue&type=script&lang=js"
export * from "./DialogElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports